var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pdf-preview"},[_c('div',{staticClass:"header"},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_vm._l((_vm.numPages),function(num){return _c('pdf',{key:num,staticClass:"pdf-item",attrs:{"src":_vm.path,"page":num}})})],2)}
var staticRenderFns = []

export { render, staticRenderFns }